"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GasLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var GasLinear = function GasLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.923 9.994a1.26 1.26 0 01.231-.483c.049.183.143.332.236.476.132.207.269.421.293.786a.973.973 0 01.003.067c0 .444-.308.805-.686.805-.378 0-.686-.361-.686-.805v-.004l.001-.045a1.11 1.11 0 01.072-.4c.067.157.185.301.378.301.063 0 .114-.056.114-.126 0-.179.003-.386.044-.572z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6 0a.8.8 0 100 1.6v1.7a3.201 3.201 0 00-2.4 3.1V12c0 1.184.643 2.219 1.6 2.772v.428a.8.8 0 00.8.8h4.8a.8.8 0 00.8-.8v-.428A3.199 3.199 0 0012.8 12V6.4a3.201 3.201 0 00-2.4-3.1V1.6a.8.8 0 000-1.6H5.6zm3.128 5.615a.132.132 0 00-.139.01c-.589.421-1.08 1.132-1.252 1.81-.119.47-.135 1.001-.137 1.351-.544-.116-.667-.93-.668-.938a.134.134 0 00-.19-.101c-.029.014-.7.355-.74 1.717-.002.045-.002.09-.002.136C5.6 10.923 6.677 12 8 12h.007A2.403 2.403 0 0010.4 9.6c0-.066-.014-.253-.014-.253-.073-.954-.518-1.553-.91-2.08-.363-.489-.676-.911-.676-1.533a.134.134 0 00-.072-.119z",
    fill: "currentColor"
  }));
};

exports.GasLinear = GasLinear;
var _default = GasLinear;
exports.default = _default;